import type {
    INTERNAL_ONLY_SYSTEM_METADATA_GLOBAL_ACCOUNT,
    TraceErrorObject,
} from 'owa-analytics-types';
import type { AnalyticsEventNames } from 'owa-analytics-events';
import type { MailboxInfo } from 'owa-client-types';

import { addErrorToCustomData } from 'owa-analytics-utils/lib/addErrorToCustomData';
import { addFinalErrorFieldsToCustomData, ignoreError } from 'owa-analytics-utils/lib/ignoreError';

import ErrorDatapoint from '../../datapoints/ErrorDatapoint';
import UsageDatapoint from '../../datapoints/UsageDatapoint';
import { logDatapoint } from '../logDatapoint';

const GREY_ERROR_TABLE = 'client_grey_error';

interface ErrorDatapointOptions {
    logInDevMode: boolean;
    errorVersion: number;
}

export function logErrorDatapoint(
    message: string,
    mailboxInfo: MailboxInfo | typeof INTERNAL_ONLY_SYSTEM_METADATA_GLOBAL_ACCOUNT | undefined,
    errorDetails: TraceErrorObject | undefined,
    options?: ErrorDatapointOptions
): void {
    try {
        if (ignoreError(message)) {
            return;
        }

        const { datapointName, customData } = addErrorToCustomData(message, errorDetails);

        // This is to allow for filtering dev-mode datapoints in a query where we don't have a reliable build number
        if (options) {
            customData.errorVersion = options.errorVersion;
        }

        if (datapointName) {
            // UsageDatapoint now expects mailbox as the second argument.
            // Cast datapointName as AnalyticsEventNames since error datapoints use dynamic names
            // derived from error message parsing, not the catalog.
            logDatapoint(
                new UsageDatapoint(datapointName as AnalyticsEventNames, mailboxInfo, customData),
                GREY_ERROR_TABLE
            );
        } else {
            const { customData: customDataWithFinalFields, table } =
                addFinalErrorFieldsToCustomData(
                    message,
                    errorDetails,
                    customData,
                    options?.logInDevMode
                );

            logDatapoint(
                new ErrorDatapoint(message, mailboxInfo, errorDetails, customDataWithFinalFields),
                table
            );
        }
    } catch {
        // TODO OW 48077
    }
}
